import { scope } from '@otto-ec/global-resources/debug';

export const loggerScope = scope('ft5.component-repository');
